// src/components/LimitReachedModal.jsx
// Modal shown when user reaches their monthly search limit

import React from 'react';
import './LimitReachedModal.css';

const LimitReachedModal = ({ 
  show, 
  onClose, 
  usage, 
  isGuest, 
  onUpgrade, 
  onSignIn 
}) => {
  if (!show) return null;

  const usedCount = usage?.used || 0;
  const limitCount = usage?.limit || 100;
  const plan = usage?.plan || 'free';

  return (
    <div className="limit-modal-overlay" onClick={onClose}>
      <div className="limit-modal" onClick={(e) => e.stopPropagation()}>
        {/* Close button */}
        <button className="limit-modal-close" onClick={onClose}>×</button>
        
        {/* Icon */}
        <div className="limit-modal-icon">
          <span>🚫</span>
        </div>

        {/* Title */}
        <h2 className="limit-modal-title">Search Limit Reached</h2>

        {/* Description */}
        <p className="limit-modal-description">
          You've used all <strong>{limitCount}</strong> of your monthly flight searches.
        </p>

        {/* Usage bar */}
        <div className="limit-modal-usage">
          <div className="limit-usage-bar">
            <div className="limit-usage-fill" style={{ width: '100%' }}></div>
          </div>
          <div className="limit-usage-text">
            <span>{usedCount} / {limitCount} searches used</span>
            <span className="limit-reset-text">Resets in {getDaysUntilReset()} days</span>
          </div>
        </div>

        {/* Options based on user type */}
        {isGuest ? (
          <div className="limit-modal-options">
            <p className="limit-option-text">
              Sign in to track your usage across devices, or upgrade for unlimited searches.
            </p>
            <button className="limit-btn-primary" onClick={onSignIn}>
              Sign In
            </button>
            <button className="limit-btn-secondary" onClick={onUpgrade}>
              View Plans →
            </button>
          </div>
        ) : plan === 'free' ? (
          <div className="limit-modal-options">
            <div className="limit-upgrade-card">
              <div className="upgrade-card-header">
                <span className="upgrade-badge">PRO</span>
                <span className="upgrade-price">$9.99<span>/month</span></span>
              </div>
              <ul className="upgrade-benefits">
                <li>✓ Unlimited flight searches</li>
                <li>✓ 25 price alerts per month</li>
                <li>✓ Advanced AI recommendations</li>
                <li>✓ Priority support</li>
              </ul>
            </div>
            <button className="limit-btn-primary" onClick={onUpgrade}>
              ⚡ Upgrade to Pro
            </button>
            <p className="limit-wait-text">
              Or wait until your limit resets on the 1st of next month.
            </p>
          </div>
        ) : (
          <div className="limit-modal-options">
            <p className="limit-option-text">
              Consider upgrading to a higher plan for more searches.
            </p>
            <button className="limit-btn-primary" onClick={onUpgrade}>
              View Plans →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// Helper function to calculate days until reset
const getDaysUntilReset = () => {
  const now = new Date();
  const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  const diffTime = nextMonth - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export default LimitReachedModal;
